import {atom} from "recoil";

export const atomDate= atom({
    key:"atom_date",
    default:""
})
export const atomGrid=atom({
    key:"atom_grid",
    default:"1"
})